import Layout from "./layout/main";
import PageRoutes from "./router/page-routes";

function App() {

  return (
    <Layout>
      <PageRoutes />
    </Layout>
  );
}

export default App;